﻿function submitForm(event) {
    event.preventDefault();
    $(event.target).parents('form').submit();
}
function markAsLoading() {
    let container = $('#van-reviews-search-loading-container');
    container.height(50); // set the height to stop moving on large desktop
    container.text('').html('<div class="d-flex justify-content-center"><div class="spinner-border" role="status"><span class="visually-hidden">Loading...</span></div></div>');
}
export function setupVanReviewSearch() {
    $(document).on('change', 'form[data-van-review-search] select', function (e) {
        markAsLoading();
        submitForm(e);
        if ($('#ManufacturerSlugSelected').val() == "search") {
            $('#ManufacturerSlug').val(''); 
        }
    });
}